import React from 'react';
import './Bone.css';

export interface BoneProps {
  /** The skeleton's own class, which gives the bone its size and shape. */
  className: string;
}

/** A placeholder block with the shimmer. */
export function Bone({ className }: BoneProps): React.ReactElement {
  return <span className={`integrations-bone ${className}`} />;
}
